// Types this distributor can assign. There is no quantity limit: what is sold
// is invoiced at month end.
export function getSellableLicenseTypes(licenseTypes) {
    return licenseTypes.filter(licenseType => licenseType.isEnabled);
}

const BILLING_ONLY = 4;

// Product of each functionality, in dropdown order. Billing-only types are not
// listed: nothing relates them, so each one is a product of its own.
const PRODUCTS = [
    { functionality: 0, key: "mod_budgets_license_product_access" },
    { functionality: 1, key: "mod_budgets_license_product_clockins" },
    { functionality: 2, key: "mod_budgets_license_product_pms" },
    { functionality: 3, key: "mod_budgets_license_product_incidents" },
    { functionality: 5, key: "mod_budgets_license_product_api_rental" },
    { functionality: 6, key: "mod_budgets_license_product_api_clockins" },
];

const MODALITIES = [
    { key: "mod_budgets_license_modality_annual", matches: type => !type.isDemo && parseInt(type.duration) === 365 },
    { key: "mod_budgets_license_modality_monthly", matches: type => !type.isDemo && parseInt(type.duration) === 30 },
    { key: "mod_budgets_license_modality_permanent", matches: type => !type.isDemo && !type.duration },
    { key: "mod_budgets_license_modality_demo", matches: type => type.isDemo },
];

function productOf(licenseType) {
    return licenseType.typeFunctionality === BILLING_ONLY
        ? licenseType.uid
        : String(licenseType.typeFunctionality);
}

function productRank(licenseType) {
    const index = PRODUCTS.findIndex(product => product.functionality === licenseType.typeFunctionality);
    return index === -1 ? PRODUCTS.length : index;
}

function modalityRank(licenseType) {
    const index = MODALITIES.findIndex(modality => modality.matches(licenseType));
    return index === -1 ? MODALITIES.length : index;
}

export function buildLicenseProductOptions(licenseTypes, t) {
    const options = new Map();
    [...licenseTypes]
        .sort((a, b) => productRank(a) - productRank(b) || a.name.localeCompare(b.name))
        .forEach(licenseType => {
            const key = PRODUCTS[productRank(licenseType)]?.key;
            options.set(productOf(licenseType), key ? t(key) : licenseType.name);
        });
    return [...options].map(([value, label]) => ({ value, label }));
}

export function buildLicenseModalityOptions(licenseTypes, product, t) {
    return licenseTypes
        .filter(licenseType => productOf(licenseType) === product)
        .sort((a, b) => modalityRank(a) - modalityRank(b) || a.name.localeCompare(b.name))
        .map(licenseType => {
            const key = MODALITIES[modalityRank(licenseType)]?.key;
            return { value: licenseType.uid, label: key ? t(key) : licenseType.name };
        });
}
